export default __webpack_public_path__ + "static/media/4.c5d270e2.png";